var map = {
	"./Actualizable/Actualizable.json": 61487,
	"./Actualizable/ActualizableProxy.json": 34068,
	"./Actualizable2/Actualizable2.json": 10830,
	"./Actualizable2/Actualizable2Proxy.json": 69566,
	"./Actualizable3/Actualizable3Proxy.json": 17754,
	"./Actualizable3/Actualizable3V2.json": 16266,
	"./Actualizable4/Actualizable4.json": 82162,
	"./Actualizable4/Actualizable4Proxy.json": 49190,
	"./Aleatorio/Aleatorio.json": 43936,
	"./Bienvenida/Bienvenida.json": 36412,
	"./Bloqueado/Bloqueado.json": 91322,
	"./CanjeImposible/CanjeImposible.json": 9380,
	"./DatosPrivados/DatosPrivados.json": 34824,
	"./Decompilar/Decompilar.json": 47505,
	"./Delegar/Delegar.json": 12903,
	"./Denegacion/Denegacion.json": 51625,
	"./Denegacion2/Denegacion2.json": 55070,
	"./Desbordamiento/Desbordamiento.json": 57212,
	"./DesdeContrato/DesdeContrato.json": 54383,
	"./ErrorFatal/ErrorFatal.json": 31540,
	"./Jeroglifico/Jeroglifico.json": 15999,
	"./ManipularStorage/ManipularStorage.json": 95045,
	"./MisionEspacial/MisionEspacial.json": 57414,
	"./MisionEspacial/MisionEspacialProxy.json": 73786,
	"./NombreConstructor/NombreConstructor.json": 97735,
	"./Pesca/Pesca.json": 29483,
	"./Puntero/Puntero.json": 45385,
	"./Reentrada/Reentrada.json": 4512,
	"./Reentrada2/Reentrada2.json": 87281,
	"./Reentrada3/Reentrada3.json": 64706,
	"./ReutilizandoValor/ReutilizandoValor.json": 27980,
	"./SaldoInesperado/SaldoInesperado.json": 22434,
	"./Token/Token.json": 71509,
	"./Trampa/Trampa.json": 86982,
	"./Transferencia/Transferencia.json": 26710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57675;